<template>
  <div class="hero-figure">
    <p class="hero-label">{{ label }}</p>
    <div class="hero-row">
      <span class="hero-value">{{ displayValue }}</span>
      <span
        v-if="delta !== null && delta !== undefined"
        class="hero-delta"
        :style="{ color: tone.color, background: tone.background }"
      >
        {{ deltaArrow }} {{ Math.abs(delta) }}{{ unit }} vs previous period
      </span>
    </div>
    <apexchart
      v-if="spark && spark.length"
      type="area"
      height="58"
      :options="sparkChartOptions"
      :series="[{ name: label, data: spark }]"
    />
  </div>
</template>

<script>
import { sparkOptions, deltaTone, SERIES } from '@/services/chartTheme';

export default {
  name: 'HeroFigure',
  props: {
    label: { type: String, required: true },
    value: { default: null },
    unit: { type: String, default: '' },
    delta: { default: null },
    spark: { type: Array, default: () => [] },
    downIsGood: { type: Boolean, default: false },
  },
  computed: {
    displayValue() {
      if (this.value === null || this.value === undefined) return '—';
      return `${this.value}${this.unit}`;
    },
    deltaArrow() {
      // Computed rather than inline: a bare `<` inside a template mustache is
      // parsed as a tag opening and fails the SFC compile.
      if (!this.delta) return '—';
      return this.delta > 0 ? '▲' : '▼';
    },
    tone() {
      return deltaTone(this.delta, this.downIsGood);
    },
    sparkChartOptions() {
      return sparkOptions(SERIES[0], this.spark.length - 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.hero-figure {
  background: white;
  border: 1px solid rgba(11, 11, 11, 0.07);
  border-radius: 10px;
  padding: 16px 20px 6px 20px;
  text-align: left;
  box-shadow: 0 1px 2px rgba(11, 11, 11, 0.04);
  transition: box-shadow 0.2s, transform 0.2s;

  &:hover {
    box-shadow: 0 4px 14px rgba(11, 11, 11, 0.08);
    transform: translateY(-1px);
  }
}
.hero-label {
  font-size: 13px;
  color: #7a7f85;
  margin: 0 0 6px 0;
}
.hero-row {
  display: flex;
  align-items: baseline;
  gap: 14px;
}
.hero-value {
  // Proportional figures, not tabular: at 44px, equal-width digits make a
  // number like 142 look loose.
  font-size: 44px;
  font-weight: 600;
  letter-spacing: -1.5px;
  line-height: 1.05;
  color: #333333;
}
.hero-delta {
  flex: 0 0 auto;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
</style>
